"use client";

import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";
import { AlertCircle, Search, RefreshCw } from "lucide-react";

const Error = ({ reset }: { reset: () => void }) => {
  const router = useRouter();
  const handleGoHome = () => {
    router.push("/");
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF5F4] to-white flex flex-col items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* Error Icon */}
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-orange-100 flex items-center justify-center">
          <AlertCircle className="w-10 h-10 text-orange-600" />
        </div>

        {/* Error Title */}
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Vendor Not Available
        </h1>

        {/* Error Message */}
        <div className="mb-8">
          <p className="text-lg text-gray-600 mb-4">
            This vendor is currently offline or doesn&apos;t exist.
          </p>
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
            <p className="text-orange-800 font-medium">
              Please explore other available vendors to continue with your
              order.
            </p>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <Button
            onClick={handleGoHome}
            className="w-full bg-[#037a6a] hover:bg-[#025e53] text-white"
            size="lg"
          >
            <Search className="w-5 h-5 mr-2" />
            Explore Other Vendors
          </Button>

          <Button
            onClick={reset}
            variant="ghost"
            className="w-full text-gray-600 hover:text-gray-800"
            size="lg"
          >
            <RefreshCw className="w-5 h-5 mr-2" />
            Try Again
          </Button>
        </div>

        {/* Additional Help Text */}
        <p className="text-sm text-gray-500 mt-6">
          If you believe this is an error, please contact our support team.
        </p>
      </div>
    </div>
  );
};

export default Error;
